import { useCallback, useEffect, useState } from 'react';
import { clearMarkCommand, getActiveMark, setMarkCommand } from '../utils/markUtils';
// @ts-ignore no types
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import UITextToolbarColorDropdown from 'rich-text-lib/components/editor/UITextToolbarColorDropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { isValidColorHex } from 'UIComponents/utils/propTypes/color';
import { Tracker } from '../../utils/usageTracker';
import { PM_CHANGE_COLOR } from '../constants/events';
import { APPLY_COLOR_POPOVER } from 'rich-text-lib/constants/usageTracking';
import { convertRgbStringToHex } from 'rich-text-lib/utils/color';
import { TextColorIcon } from 'foundations-assets/icons/components/TextColorIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const setTextColor = attrs => setMarkCommand(schema => schema.marks.text_color, attrs);
export const clearTextColor = () => clearMarkCommand(schema => schema.marks.text_color);
export default function TextColorMark({
  defaultTextColor
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [colorValue, setColorValue] = useState(defaultTextColor);
  useEffect(() => {
    const activeTextColor = getActiveMark(editorState, editorState.schema.marks.text_color);
    const color = activeTextColor ? activeTextColor.attrs.color : null;
    if (!color) {
      setColorValue(defaultTextColor);
      return;
    }
    try {
      setColorValue(convertRgbStringToHex(color));
    } catch (_e) {
      if (isValidColorHex(color)) {
        setColorValue(color);
      } else {
        setColorValue(defaultTextColor);
      }
    }
  }, [editorState, setEditorState, setColorValue, defaultTextColor]);
  const applyTextColor = useCallback(evt => {
    const {
      color
    } = evt.target.value;
    setTextColor({
      color
    })(editorState, tr => {
      const newTr = tr.setMeta('text_color', color);
      setEditorState(editorState.apply(newTr));
    });
    setColorValue(color);
    Tracker.track(PM_CHANGE_COLOR, {
      action: APPLY_COLOR_POPOVER,
      format: 'forecolor'
    });
  }, [editorState, setEditorState, setColorValue]);
  const resetTextColor = useCallback(() => {
    clearTextColor()(editorState, tr => {
      const newTr = tr.setMeta('text_color', null);
      setEditorState(editorState.apply(newTr));
    });
    setColorValue(defaultTextColor);
    Tracker.track(PM_CHANGE_COLOR, {
      action: APPLY_COLOR_POPOVER,
      format: 'forecolor'
    });
  }, [editorState, setEditorState, setColorValue, defaultTextColor]);
  return /*#__PURE__*/_jsx(UITextToolbarColorDropdown, {
    color: {
      color: colorValue,
      alpha: 100
    },
    DropdownContent: ColorPickerPopoverBody,
    onColorChange: applyTextColor,
    onResetClick: resetTextColor,
    icon: "textColor",
    Icon: TextColorIcon,
    menuWidth: 300,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.textColor"
    }),
    "data-test-id": "font-colors-dropdown"
  });
}